import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '@/shared/api';
import type { TypeSTTConfig, TypeSTTConfigForm } from '@intone/shared/types';

export function useSttConfigs(configId: number) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['stt-configs', configId],
    queryFn: async () => {
      return apiClient<TypeSTTConfig[]>(`/stt-configs/${configId}`);
    },
  });
}

export function useSaveSttConfig() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: TypeSTTConfigForm & {
      id?: number;
      agentId: string;
    }) => {

      return apiClient<TypeSTTConfig>('/stt-configs/save', {
        method: 'POST',
        body: JSON.stringify(config),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['stt-configs'] });
    },
  });
}